import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer } from 'react';
import classNames from 'classnames';
import { AspectRatioView } from './aspect-ratio-view';
import { useMobile } from '../hooks/use-mobile';
import { Image } from './image';
import Play from '../icons/play';
export var VideoPathIframe = function VideoPathIframe(_ref) {
  var aspectRatio = _ref.aspectRatio,
    coverImage = _ref.coverImage,
    _ref$imageClassName = _ref.imageClassName,
    imageClassName = _ref$imageClassName === void 0 ? '' : _ref$imageClassName,
    _ref$imageStyle = _ref.imageStyle,
    imageStyle = _ref$imageStyle === void 0 ? {} : _ref$imageStyle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$playBtnClassName = _ref.playBtnClassName,
    playBtnClassName = _ref$playBtnClassName === void 0 ? '' : _ref$playBtnClassName,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    filePathValue = _ref.filePathValue;
  var _useReducer = useReducer(function () {
      return true;
    }, false),
    active = _useReducer[0],
    setActive = _useReducer[1];
  var mobile = useMobile();
  if (active) {
    return _jsx(AspectRatioView, Object.assign({
      className: 'w-full',
      aspectRatio: mobile ? aspectRatio.mobile : aspectRatio.pc
    }, {
      children: _jsx("iframe", {
        allowFullScreen: true,
        width: '100%',
        height: '100%',
        src: mobile ? filePathValue.mobile.videoPath : filePathValue.web.videoPath,
        title: 'YouTube video player',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      })
    }));
  }
  return _jsxs("div", Object.assign({
    style: style,
    className: classNames('relative w-full', className)
  }, {
    children: [_jsx(Play, {
      className: classNames('cursor-pointer absolute z-2', playBtnClassName),
      handleClick: setActive
    }), _jsx(Image, {
      className: imageClassName,
      style: imageStyle,
      src: coverImage
    })]
  }));
};